import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetSuppliesLookup,
  CategoryPlans,
  GetOrderAssociates,
  GetReports,
  Organizations,
  Plans,
  ProposalBySeller,
  ProposalGetAssociates,
  Sellers,
  Specialties,
  SearchAssociates,
  Offices,
} from '../../../store/actions';

/**
 * ReportsInjection is responsible for injecting the methods about store.
 *
 * @return
 *  get: () => Void
 *
 *
 */
export const ReportsInjection = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   */
  const getReports = async () => {
    dispatch(GetReports());
  };

  const getSuppliersLookup = async () => {
    dispatch(GetSuppliesLookup());
  };

  const getSellers = async () => {
    dispatch(Sellers());
  };

  const getCategoryPlans = async () => {
    dispatch(CategoryPlans());
  };

  const getPlans = async () => {
    dispatch(Plans());
  };

  /**
   * @return Void
   */
  const getOrganizations = () => {
    dispatch(Organizations());
  };

  const proposalBySeller = (data) => {
    dispatch(ProposalBySeller(data));
  };

  const getOrderAssociates = async (params) => {
    dispatch(GetOrderAssociates(params));
  };

  const proposalGetAssociates = useCallback(
    (id) => {
      dispatch(ProposalGetAssociates(id));
    },
    [dispatch]
  );

  const getSpecialties = () => {
    dispatch(Specialties());
  };

  const getSearchAssociates = (data) => {
    dispatch(SearchAssociates(data));
  };

  const getOffices = async () => {
    dispatch(Offices());
  };

  /**
   * @variables
   *
   *
   */
  const {
    associates,
    categoryPlans,
    sellers,
    organizations,
    reports,
    reportsBySeller,
    proposalsAssociates,
    plans,
    specialties,
    success,
    reportsSearchAssociates,
    suppliersLookup,
    offices,
  } = useSelector((state) => ({
    plans: state.Plans.plans,
    sellers: state.Sellers.sellers,
    specialties: state.Specialties.specialties,
    associates: state.Associates.associates,
    categoryPlans: state.CategoryPlans.categoryPlans,
    organizations: state.Organizations.organizations,
    reports: state.Reports.reports,
    reportsBySeller: state.Reports.reportsBySeller,
    proposalsAssociates: state.Proposal.proposalsAssociates,
    success: state.Associates.success,
    reportsSearchAssociates: state.Reports.reportsSearchAssociates,
    suppliersLookup: state.SuppliesList.suppliersLookup,
    offices: state.Offices.offices,
  }));

  return {
    getPlans,
    getSellers,
    getOffices,
    getCategoryPlans,
    getOrganizations,
    getOrderAssociates,
    plans,
    offices,
    sellers,
    associates,
    categoryPlans,
    organizations,
    getReports,
    proposalBySeller,
    reports,
    reportsBySeller,
    proposalGetAssociates,
    proposalsAssociates,
    getSpecialties,
    specialties,
    success,
    getSearchAssociates,
    reportsSearchAssociates,
    getSuppliersLookup,
    suppliersLookup,
  };
};
